/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type VehicleInteractionButtonFragment = {
  __typename?: 'Vehicle'
  id: string
  label: number | null
  licensePlate: string | null
  serviceAreaUUID: string
  fleet: { __typename?: 'Fleet'; id: string } | null
  lastVehicleInteraction: {
    __typename?: 'VehicleInteraction'
    type: Types.VehicleInteractionType
  } | null
}

export const VehicleInteractionButtonFragmentDoc = gql`
    fragment VehicleInteractionButton on Vehicle {
  fleet {
    id
  }
  id
  label
  licensePlate
  lastVehicleInteraction {
    type
  }
  serviceAreaUUID
}
    `
